import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style22({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="originalName"
      activeItemIconName="translate"
      onClick={onClick}
    />
  );
}
